import { toastPositions } from './lib/positions';
import { toastManager } from './lib/toastManager';
import { toastTypes } from './lib/toastTypes';
const defaultOptions = {
  position: toastPositions.BOTTOM
};

const makeToast = intent => (content, options) => toastManager.make(content, Object.assign({}, defaultOptions, options, {
  intent
}));

const toast = {
  primary: makeToast(toastTypes.PRIMARY),
  secondary: makeToast(toastTypes.SECONDARY),
  success: makeToast(toastTypes.SUCCESS),
  warning: makeToast(toastTypes.WARNING),
  danger: makeToast(toastTypes.DANGER),
  close: toastManager.close,
  closeAll: toastManager.closeAll
};
export { toast };